module.exports = __webpack_public_path__ + "static/media/cross-platform.2d4f5818.svg";